import { Section } from '@factorialco/deprecated-design-system'
import { TimeTrackingClockInPageQuery } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import NewOvertimeCompensation from 'modules/attendance/components/SettingItemPage/TimeTracking/Compensation/Content/NewOvertimeCompensation'
import type AttendanceSetting from 'modules/attendance/store/models/AttendanceSetting'
import type BalanceCarryover from 'modules/attendance/store/models/BalanceCarryover'

type AttendanceOvertimePool =
  TimeTrackingClockInPageQuery['attendance']['overtimePoolsConnection']['nodes'][number]

export interface Props {
  attendanceSetting: AttendanceSetting
  timeoffCompensationEnabled: boolean
  balanceCarryover?: BalanceCarryover
  setBalanceCarryover?: (balanceCarryover: BalanceCarryover) => void
  hasExtraHourRules: boolean
  hasTimeOffExtraHourRules: boolean
  hasLimitBalancePool: boolean
  hasManualAllocation: boolean
  overtimePools: AttendanceOvertimePool[]
  hasBankOfHoursTransferFrequency: boolean
}

const CompensationConditions = ({
  attendanceSetting,
  timeoffCompensationEnabled,
  balanceCarryover,
  setBalanceCarryover,
  hasExtraHourRules,
  hasTimeOffExtraHourRules,
  overtimePools,
  hasLimitBalancePool,
  hasManualAllocation,
  hasBankOfHoursTransferFrequency,
}: Props) => {
  return (
    <>
      {hasBankOfHoursTransferFrequency ? (
        <Section
          illustration="document-folder-board-edit"
          title={i18n.t('time_tracking.settings.compensation_conditions.title')}
          description={i18n.t('time_tracking.settings.compensation_conditions.description')}
        >
          <NewOvertimeCompensation
            attendanceSetting={attendanceSetting}
            timeoffCompensationEnabled={timeoffCompensationEnabled}
            balanceCarryover={balanceCarryover}
            setBalanceCarryover={setBalanceCarryover}
            hasExtraHourRules={hasExtraHourRules}
            hasTimeOffExtraHourRules={hasTimeOffExtraHourRules}
            overtimePools={overtimePools}
            hasLimitBalancePool={hasLimitBalancePool}
            hasManualAllocation={hasManualAllocation}
          />
        </Section>
      ) : (
        <></>
      )}
    </>
  )
}

export default observer(CompensationConditions)
